import { render, staticRenderFns } from "./FacebookAuth.vue?vue&type=template&id=5f875cb5&scoped=true"
import script from "./FacebookAuth.vue?vue&type=script&lang=js"
export * from "./FacebookAuth.vue?vue&type=script&lang=js"
import style0 from "./FacebookAuth.vue?vue&type=style&index=0&id=5f875cb5&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f875cb5",
  null
  
)

export default component.exports